const UIStrategy = require('./ui_strategy');

class UIStrategyConfirmed extends UIStrategy {
    constructor(bookingInfo, view, templates, keys, constants = {}) {
        super(bookingInfo, view, templates, keys, constants);
    }

    isProductAvailable() {
        return true;
    }

    getData() {
        const parentData = super.getData();
        return Odigeo._.merge({}, parentData, {
            parent: {
                base: {
                    button: {
                        text: this.keys.buttonLabel,
                        classes: this.CONST.ctaClasses,
                    },
                    persuasiveMessage: {
                        text: this.keys.persuasiveMessage,
                        classes: this.CONST.persuasiveMessageTextClasses,
                    },
                },
            },
        });
    }
}

module.exports = UIStrategyConfirmed;
